// extracted by mini-css-extract-plugin
export default {"defaultAppContainerContainer":"_default-app-container_defaultAppContainerContainer__4N1Cc","clientSwitcher":"_default-app-container_clientSwitcher__iFkrR"};